import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IDotIconProps extends IConDefaultType {}

function DotIcon({ className, size = 24, rotate, flip, color = '#8A8A8A' }: IDotIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.00033" cy="8" r="1.33333" transform="rotate(-90 8.00033 8)" fill={color} />
      </svg>
    </i>
  );
}

export default DotIcon;
